import type { SVGProps } from "react";

// 腾讯视频：经典四色流动环形流光与高光立体播放三角
export function TencentVideoIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={40}
      height={40}
      {...props}
    >
      <defs>
        <radialGradient id="tx-glow" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#ff5722" stopOpacity="0.25" />
          <stop offset="100%" stopColor="#ff5722" stopOpacity="0" />
        </radialGradient>
        <linearGradient id="tx-coral" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#ff5252" />
          <stop offset="100%" stopColor="#ff7a00" />
        </linearGradient>
        <linearGradient id="tx-green" x1="0%" y1="100%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#00c853" />
          <stop offset="100%" stopColor="#64dd17" />
        </linearGradient>
        <linearGradient id="tx-blue" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#00b0ff" />
          <stop offset="100%" stopColor="#2979ff" />
        </linearGradient>
        <filter id="tx-shadow" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="3" stdDeviation="3" floodColor="#ff5722" floodOpacity="0.3" />
        </filter>
      </defs>
      <circle cx="24" cy="24" r="22" fill="#ffffff" />
      <circle cx="24" cy="24" r="22" fill="url(#tx-glow)" />
      {/* 环形彩色三色光翼 */}
      <path
        d="M24 6C14.059 6 6 14.059 6 24c0 3.824 1.196 7.37 3.23 10.308L14 30.5C12.75 28.6 12 26.39 12 24c0-6.627 5.373-12 12-12 2.76 0 5.3 0.93 7.34 2.5L35 11C31.9 7.89 28.17 6 24 6z"
        fill="url(#tx-coral)"
      />
      <path
        d="M42 24c0 6.627-5.373 12-12 12-3.1 0-5.91-1.18-8.03-3.12l-4.24 3.75C20.65 39.52 24.16 41 28 41c9.941 0 18-8.059 18-18 0-3.37-.93-6.52-2.55-9.22l-4.12 3.63C40.66 19.38 42 21.56 42 24z"
        fill="url(#tx-blue)"
      />
      <path
        d="M10.23 35.308C13.8 40.16 19.54 43 26 43c2.08 0 4.07-.31 5.95-.88l-2.07-5.63C28.2 36.83 26.63 37 25 37c-4.7 0-8.83-2.7-10.88-6.63l-3.89 4.94z"
        fill="url(#tx-green)"
      />
      {/* 核心高光播放三角 */}
      <path
        d="M19.5 16.5a1.5 1.5 0 012.3-.12l11 8.5a1.5 1.5 0 010 2.24l-11 8.5a1.5 1.5 0 01-2.3-1.12v-18z"
        fill="url(#tx-coral)"
        filter="url(#tx-shadow)"
      />
      <path
        d="M20 17.8v12.4l8.2-6.2L20 17.8z"
        fill="#ffffff"
        opacity="0.95"
      />
    </svg>
  );
}

// 爱奇艺：荧光翡翠绿立体圆角方屏与晶莹剔透播放键
export function IqiyiIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={40}
      height={40}
      {...props}
    >
      <defs>
        <linearGradient id="iq-bg" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#00fa9a" />
          <stop offset="100%" stopColor="#00c853" />
        </linearGradient>
        <linearGradient id="iq-border" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#00e676" />
          <stop offset="100%" stopColor="#00b348" />
        </linearGradient>
        <filter id="iq-glow" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="3" stdDeviation="3.5" floodColor="#00c853" floodOpacity="0.35" />
        </filter>
      </defs>
      {/* 绿色圆角外壳 */}
      <rect
        x="5"
        y="5"
        width="38"
        height="38"
        rx="12"
        fill="#ffffff"
        stroke="url(#iq-border)"
        strokeWidth="3.5"
        filter="url(#iq-glow)"
      />
      {/* 绿色屏幕内环 */}
      <rect
        x="10.5"
        y="10.5"
        width="27"
        height="27"
        rx="8"
        fill="url(#iq-bg)"
      />
      {/* 内部高光播放三角 */}
      <path
        d="M21 18.2a1 1 0 011.55-.83l9 5.8a1 1 0 010 1.66l-9 5.8a1 1 0 01-1.55-.83v-11.6z"
        fill="#ffffff"
      />
      {/* 顶角微光点缀 */}
      <circle cx="34" cy="14" r="2" fill="#ffffff" opacity="0.8" />
    </svg>
  );
}

// 优酷：标志性电光蓝与动感玫红双环相扣播放标
export function YoukuIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={40}
      height={40}
      {...props}
    >
      <defs>
        <linearGradient id="yk-blue" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#0091ea" />
          <stop offset="100%" stopColor="#0069c0" />
        </linearGradient>
        <linearGradient id="yk-pink" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#ff4081" />
          <stop offset="100%" stopColor="#e91e63" />
        </linearGradient>
        <filter id="yk-shadow" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="3" stdDeviation="3" floodColor="#0091ea" floodOpacity="0.3" />
        </filter>
      </defs>
      <circle cx="24" cy="24" r="22" fill="#ffffff" />
      {/* 优酷蓝色大环 */}
      <circle
        cx="24"
        cy="24"
        r="16"
        stroke="url(#yk-blue)"
        strokeWidth="4"
        filter="url(#yk-shadow)"
      />
      {/* 右侧玫红圆弧与播放点缀 */}
      <path
        d="M34 16a16 16 0 010 16"
        stroke="url(#yk-pink)"
        strokeWidth="4.5"
        strokeLinecap="round"
      />
      {/* 中心立体双色播放三角 */}
      <path
        d="M20 17.5a1.2 1.2 0 011.83-1.02l9.5 5.5a1.2 1.2 0 010 2.04l-9.5 5.5A1.2 1.2 0 0120 28.5v-11z"
        fill="url(#yk-blue)"
      />
      <path
        d="M24 24l5.5-3.2a1.2 1.2 0 010 2.04L24 26v-2z"
        fill="url(#yk-pink)"
      />
      <circle cx="20.5" cy="18.5" r="1.5" fill="#ffffff" opacity="0.85" />
    </svg>
  );
}

// 哔哩哔哩：标志性天蓝色数码小电视、天线与萌系笑脸
export function BilibiliIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={40}
      height={40}
      {...props}
    >
      <defs>
        <linearGradient id="bili-cyan" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#23ade5" />
          <stop offset="100%" stopColor="#009cd9" />
        </linearGradient>
        <linearGradient id="bili-pink" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#fb7299" />
          <stop offset="100%" stopColor="#e0567f" />
        </linearGradient>
        <filter id="bili-shadow" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="3" stdDeviation="3" floodColor="#23ade5" floodOpacity="0.3" />
        </filter>
      </defs>
      <circle cx="24" cy="24" r="22" fill="#ffffff" />
      {/* 顶部两只小天线 */}
      <path
        d="M16 9l5 6M32 9l-5 6"
        stroke="url(#bili-cyan)"
        strokeWidth="3.5"
        strokeLinecap="round"
      />
      {/* 经典电视机圆角外框 */}
      <rect
        x="7"
        y="14"
        width="34"
        height="26"
        rx="7"
        fill="url(#bili-cyan)"
        filter="url(#bili-shadow)"
      />
      {/* 内部白色荧光屏 */}
      <rect
        x="10.5"
        y="17.5"
        width="27"
        height="19"
        rx="4.5"
        fill="#ffffff"
      />
      {/* 萌系双眼与小微笑 */}
      <circle cx="17.5" cy="24.5" r="2.2" fill="#23ade5" />
      <circle cx="30.5" cy="24.5" r="2.2" fill="#23ade5" />
      <path
        d="M21 29c1.2 1.5 4.8 1.5 6 0"
        stroke="#23ade5"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
      {/* 粉嫩小腮红 */}
      <circle cx="14" cy="28" r="1.5" fill="url(#bili-pink)" opacity="0.8" />
      <circle cx="34" cy="28" r="1.5" fill="url(#bili-pink)" opacity="0.8" />
    </svg>
  );
}

// QQ音乐：祖母绿音胶圆盘上跃动的金丝雀黄金高光音符
export function QqMusicIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={40}
      height={40}
      {...props}
    >
      <defs>
        <linearGradient id="qq-green" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#1dd1a1" />
          <stop offset="100%" stopColor="#10ac84" />
        </linearGradient>
        <linearGradient id="qq-gold" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#fed330" />
          <stop offset="100%" stopColor="#f39c12" />
        </linearGradient>
        <filter id="qq-shadow" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="3" stdDeviation="3" floodColor="#10ac84" floodOpacity="0.35" />
        </filter>
      </defs>
      <circle cx="24" cy="24" r="22" fill="#ffffff" />
      {/* 翡翠绿底色胶片 */}
      <circle
        cx="24"
        cy="24"
        r="18"
        fill="url(#qq-green)"
        filter="url(#qq-shadow)"
      />
      <circle cx="24" cy="24" r="14.5" stroke="#ffffff" strokeWidth="1" opacity="0.25" />
      <circle cx="24" cy="24" r="11" stroke="#ffffff" strokeWidth="0.8" opacity="0.2" />
      {/* 标志性黄金立体小飞鸟音符 */}
      <path
        d="M20 30.5c-2.48 0-4.5-1.79-4.5-4s2.02-4 4.5-4c1.1 0 2.1.36 2.9 0.96V14.5a1.2 1.2 0 011.02-1.19l8-1.2A1.2 1.2 0 0133.2 13.3v4.2a1.2 1.2 0 01-1.02 1.19L26 19.8v7.2c0 2.21-2.02 4-4.5 4h-1.5z"
        fill="url(#qq-gold)"
      />
      {/* 音符高光弧 */}
      <circle cx="19.5" cy="26" r="2.2" fill="#ffffff" opacity="0.5" />
      <path d="M25 15.2l6-0.9v2.2l-6 0.9v-2.2z" fill="#ffffff" opacity="0.6" />
    </svg>
  );
}

// 网易云音乐：极具辨识度的高饱和中国红黑胶唱片经典旋涡
export function NeteaseMusicIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={40}
      height={40}
      {...props}
    >
      <defs>
        <linearGradient id="ne-red" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#ff4d4d" />
          <stop offset="100%" stopColor="#e60026" />
        </linearGradient>
        <filter id="ne-shadow" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="3" stdDeviation="3.5" floodColor="#e60026" floodOpacity="0.38" />
        </filter>
      </defs>
      <circle cx="24" cy="24" r="22" fill="#ffffff" />
      {/* 标志性网易红底盘 */}
      <circle
        cx="24"
        cy="24"
        r="18"
        fill="url(#ne-red)"
        filter="url(#ne-shadow)"
      />
      {/* 白色经典旋涡音符曲线 */}
      <path
        d="M24 10.5c-7.45 0-13.5 6.05-13.5 13.5S16.55 37.5 24 37.5c6.5 0 11.9-4.6 13.2-10.7.2-.9-.4-1.8-1.3-1.8h-.5c-.8 0-1.5.6-1.7 1.4-1 4.5-5 7.9-9.7 7.9-5.5 0-10-4.5-10-10s4.5-10 10-10c4.1 0 7.7 2.5 9.1 6.3.3.8 1.1 1.3 1.9 1.1.9-.2 1.4-1.1 1.1-1.9-1.8-5-6.6-8.3-12.1-8.3z"
        fill="#ffffff"
      />
      <circle cx="24" cy="24" r="4.5" fill="#ffffff" />
      <circle cx="24" cy="24" r="2" fill="url(#ne-red)" />
    </svg>
  );
}

// 国服游戏：电竞紫蓝极速手柄与高灵敏微动晶体
export function CnGamesIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={40}
      height={40}
      {...props}
    >
      <defs>
        <linearGradient id="game-purple" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#8c7ae6" />
          <stop offset="100%" stopColor="#574b90" />
        </linearGradient>
        <linearGradient id="game-cyan" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#00d2d3" />
          <stop offset="100%" stopColor="#01a3a4" />
        </linearGradient>
        <filter id="game-shadow" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="3" stdDeviation="3.5" floodColor="#8c7ae6" floodOpacity="0.35" />
        </filter>
      </defs>
      <circle cx="24" cy="24" r="22" fill="#ffffff" />
      {/* 紫蓝电竞流线手柄 */}
      <path
        d="M13.5 16h21c3.5 0 6.5 2.5 7.2 6l2.1 10.5c.6 3.1-1.8 5.9-5 5.5-2.2-.3-4-1.9-4.8-4l-1.5-4.5c-.5-1.5-1.9-2.5-3.5-2.5h-10c-1.6 0-3 1-3.5 2.5l-1.5 4.5c-.8 2.1-2.6 3.7-4.8 4-3.2.4-5.6-2.4-5-5.5l2.1-10.5c.7-3.5 3.7-6 7.4-6z"
        fill="url(#game-purple)"
        filter="url(#game-shadow)"
      />
      {/* 十字键 (白色高光) */}
      <rect x="15" y="21" width="3" height="7" rx="1.5" fill="#ffffff" />
      <rect x="13" y="23" width="7" height="3" rx="1.5" fill="#ffffff" />
      {/* ABXY 按钮 */}
      <circle cx="33" cy="22" r="1.6" fill="url(#game-cyan)" />
      <circle cx="30" cy="24.5" r="1.6" fill="#ff7675" />
      <circle cx="36" cy="24.5" r="1.6" fill="#ffeaa7" />
      <circle cx="33" cy="27" r="1.6" fill="#55efc4" />
      {/* 顶部极光灯条 */}
      <path
        d="M20 18.5h8"
        stroke="url(#game-cyan)"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

// 统一品牌图标匹配辅助组件
export function BrandAppIcon({
  serviceId,
  className,
  size = 40,
}: {
  serviceId: string;
  className?: string;
  size?: number;
}) {
  const commonProps = { width: size, height: size, className };
  switch (serviceId) {
    case "tencent-video":
      return <TencentVideoIcon {...commonProps} />;
    case "iqiyi":
      return <IqiyiIcon {...commonProps} />;
    case "youku":
      return <YoukuIcon {...commonProps} />;
    case "bilibili":
      return <BilibiliIcon {...commonProps} />;
    case "qq-music":
      return <QqMusicIcon {...commonProps} />;
    case "netease-music":
      return <NeteaseMusicIcon {...commonProps} />;
    case "cn-games":
      return <CnGamesIcon {...commonProps} />;
    default:
      return <CnGamesIcon {...commonProps} />;
  }
}
